import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { UploadIcon } from 'assets/SVGIcons'

const styles = theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '30px 0 20px',
  },
  title: {
    fontSize: 14,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  subtitle: {
    color: theme.palette.disabled.main,
  },
  helperText: {
    fontSize: 12,
    marginTop: 2,
    color: theme.palette.disabled.main,
  },
})

const ImageUploadPlaceHolder = ({ classes, helperText }) => (
  <div className={classes.container}>
    <UploadIcon
      style={{
        width: 31,
        height: 38,
        marginLeft: 0,
        marginTop: 0,
      }}
    />
    <Typography className={classes.title} color="primary">
      Drag and drop
    </Typography>
    <Typography className={classes.subtitle}>
      your files here or browse files
    </Typography>
    <Typography className={classes.helperText}>{helperText}</Typography>
  </div>
)

ImageUploadPlaceHolder.propTypes = {
  classes: PropTypes.object,
  helperText: PropTypes.string,
}

export default withStyles(styles)(ImageUploadPlaceHolder)



// WEBPACK FOOTER //
// ./src/components/atoms/ImageUploadPlaceholder.js